import { InputHTMLAttributes } from 'react';
import './InputSlider.scss';

interface IInputSliderProps extends InputHTMLAttributes<HTMLInputElement> {}

const InputSlider = (props: IInputSliderProps) => {
  const min = Number(props.min ?? 0);
  const max = Number(props.max ?? 100);
  const value = Number(props.value ?? 0);
  const ratio = max === min ? 0 : (value - min) / (max - min);
  const percent = Math.min(100, Math.max(0, ratio * 100));

  return (
    <input
      type='range'
      {...props}
      className={`input-slider ${props.className ?? ''}`}
      style={{
        background: `linear-gradient(to right, var(--slider-fill, var(--primary)) ${percent}%, var(--slider-track, var(--app-background)) ${percent}%)`,
        ...props.style,
      }}
    />
  );
};

export default InputSlider;
